<template>
  <div class="wrapper">
    <div class="main ">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center"
            >
              <h2 class="title text-center">
                {{ $t("etudes.procedure.titre") }}
              </h2>
              <h5 class="description">
                {{ $t("etudes.procedure.sous-titre") }}
              </h5>
            </div>
          </div>
          <div class="features text-center">
            <div class="md-layout">
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100 bg-info image"
                :style="headerStyle"
              ></div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <h4 class="info-title">
                    {{ $t("etudes.procedure.niveau1.titre") }}
                  </h4>
                  <p>
                    {{ $t("etudes.procedure.niveau1.detail") }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <h4 class="info-title">
                    {{ $t("etudes.procedure.niveau2.titre") }}
                  </h4>
                  <p>
                    {{ $t("etudes.procedure.niveau2.detail") }}
                  </p>
                </div>
              </div>
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100 image"
                :style="headerStyle1"
              ></div>
            </div>
          </div>

          <div class="features text-center">
            <div class="md-layout">
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100 bg-info image"
                :style="headerStyle2"
              ></div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <h4 class="info-title">
                    {{ $t("etudes.procedure.niveau3.titre") }}
                  </h4>
                  <p>
                    {{ $t("etudes.procedure.niveau3.detail") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <h4 class="info-title">
                    {{ $t("etudes.procedure.niveau4.titre") }}
                  </h4>
                  <p>
                    {{ $t("etudes.procedure.niveau4.detail") }}
                  </p>
                </div>
              </div>
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100 image"
                :style="headerStyle3"
              ></div>
            </div>
          </div>

          <div class="features text-center">
            <div class="md-layout">
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100 bg-info image"
                :style="headerStyle4"
              ></div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <h4 class="info-title">
                    {{ $t("etudes.procedure.niveau5.titre") }}
                  </h4>
                  <p>
                    {{ $t("etudes.procedure.niveau5.detail") }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <h4 class="info-title">
                    {{ $t("etudes.procedure.niveau6.titre") }}
                  </h4>
                  <p>
                    {{ $t("etudes.procedure.niveau6.detail") }}
                  </p>
                </div>
              </div>
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100 image"
                :style="headerStyle5"
              ></div>
            </div>
          </div>

          <div class="features text-center">
            <div class="md-layout">
              <div
                class="md-layout-item md-medium-size-33 md-small-size-100 bg-info image"
                :style="headerStyle6"
              ></div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <h4 class="info-title">
                    {{ $t("etudes.procedure.niveau7.titre") }}
                  </h4>
                  <p>
                    {{ $t("etudes.procedure.niveau7.detail") }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <h2 class="title text-center">
      <md-button href="#/procedure" class="md-success md-lg text-center">{{
        $t("etudes.procedure.btn")
      }}</md-button>
    </h2>
  </div>
</template>

<script>
export default {
  bodyClass: "etude",
  props: {
    admission: {
      type: String,
      default: require("@/assets/img/admission.jpeg")
    },
    garant: {
      type: String,
      default: require("@/assets/img/garant.jpeg")
    },
    permis: {
      type: String,
      default: require("@/assets/img/permis.jpeg")
    },
    visa: {
      type: String,
      default: require("@/assets/img/visa.jpeg")
    },
    logement: {
      type: String,
      default: require("@/assets/img/logement.jpeg")
    },
    billet: {
      type: String,
      default: require("@/assets/img/billet.jpeg")
    },
    voyage: {
      type: String,
      default: require("@/assets/img/voyage.jpeg")
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.admission})`
      };
    },
    headerStyle1() {
      return {
        backgroundImage: `url(${this.garant})`
      };
    },
    headerStyle2() {
      return {
        backgroundImage: `url(${this.permis})`
      };
    },
    headerStyle3() {
      return {
        backgroundImage: `url(${this.logement})`
      };
    },
    headerStyle4() {
      return {
        backgroundImage: `url(${this.visa})`
      };
    },
    headerStyle5() {
      return {
        backgroundImage: `url(${this.billet})`
      };
    },
    headerStyle6() {
      return {
        backgroundImage: `url(${this.voyage})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}
.md-layout-item {
  // background-color: #00c853;
}
.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
